import * as ST from '@platform/shared-types';
import type { EmailCategoryKey } from '@platform/shared-types';

/*
 * Small-fixes item 27 (same rule as platform-app's B-I1 `visibleEmailCategoryKeys`): a category
 * that belongs to one product line (the `property` "Property & Rent" category) is listed only for
 * a business on that line. A missing/unknown line is Ruby Till, so a Ruby Till tenant never sees
 * it. Runtime reads are GUARDED at module scope (CI may build against an older shared-types build
 * that lacks EMAIL_CATEGORY_LINES); the fallback mirrors today's shared-types data.
 */
const CATEGORY_LINES: Partial<Record<string, string>> = (ST as any).EMAIL_CATEGORY_LINES ?? { property: 'rubyestate' };
const ALL_KEYS: EmailCategoryKey[] = ((ST as any).EMAIL_CATEGORY_KEYS as EmailCategoryKey[] | undefined) ?? [];

export function emailCategoryKeysFor(productLine?: string | null): EmailCategoryKey[] {
  const line = productLine === 'rubyestate' ? 'rubyestate' : 'rubytill';
  return ALL_KEYS.filter((k) => !CATEGORY_LINES[k] || CATEGORY_LINES[k] === line);
}
